module.exports = __webpack_public_path__ + "img/ico-plus.039da6c2.svg";